module.exports = __webpack_public_path__ + "img/Secobarbital (BAR).e9660022.png";